var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0348 53.8651H11.0667C8.83779 53.8651 7.06293 52.0903 7.06293 49.8614V17.6663C7.06293 15.4374 8.83779 13.6625 11.0667 13.6625H23.532L27.4944 8.25537H38.5151L42.1474 13.6625H54.0761C56.305 13.6625 58.0798 15.4374 58.0798 17.6663V49.8614C58.0385 52.0903 56.2637 53.8651 54.0348 53.8651Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.776 45.775C39.3413 45.775 44.6635 40.4529 44.6635 33.8876C44.6635 27.3224 39.3413 22.0002 32.776 22.0002C26.2108 22.0002 20.8886 27.3224 20.8886 33.8876C20.8886 40.4529 26.2108 45.775 32.776 45.775Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9476 33.884C26.9476 30.6665 29.5464 28.0265 32.8051 28.0265",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5b831719c7d336778ff5085b37bfa328.svg";
export { ForwardRef as ReactComponent };